import React from "react";
import { PathwayFormGroup, PathwayLabel } from "../../StyledComponents/PathwayForm";
import { Input, Label } from "reactstrap";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import usePathwayInputGroup from "../../../_hooks/usePathwayInputGroup";
import MandatoryStar from "../MandatoryStar";
import stringUtils from "../../../_services/string-utils";
import { PathwayTooltip } from "../PathwayTooltip";
import { PathwayEditButton } from "../PathwayButtons";

const PathwayTextInputGroup = (props) => {
    const { valid, blurredAfterInvalid, mandatory, isNotFilled, handleChange, onBlur, inputRef } = usePathwayInputGroup(
        props.name,
        props.value,
        props.mandatory,
        props.submitted,
        props.autoFocus,
        props.triggerOnBlur,
        props.inputValidation,
        props.handleChange
    );

    return (
        <CustomFormGroup>
            {props.label && (
                <>
                    <TooltipInputGroup>
                        <LabelWrapper data-cy={props.dataCy ? props.dataCy + "-label" : undefined}>
                            <LabelParagraph strong={props.strongLabel}>{props.label}</LabelParagraph>{" "}
                            {mandatory && <MandatoryStar />}
                        </LabelWrapper>
                        {props.tooltip && (
                            <PathwayTooltip id={props.dataCy + "-tooltip"} iconSize="var(--iconSize-xs)">
                                {props.tooltip}
                            </PathwayTooltip>
                        )}
                        {props.handleAction && <PathwayEditButton onClick={props.handleAction} />}
                    </TooltipInputGroup>
                </>
            )}

            {blurredAfterInvalid ? (
                <Input
                    type={props.type ? props.type : "text"}
                    name={props.name}
                    data-cy={props.dataCy}
                    placeholder={props.placeHolder}
                    value={props.value || ""}
                    disabled={props.disabled}
                    pattern={props.pattern}
                    maxLength={props.maxLength}
                    onChange={handleChange}
                    onBlur={onBlur}
                    valid={valid}
                    invalid={!valid}
                    min={props.min}
                    max={props.max}
                    autoComplete={props.autoComplete}
                />
            ) : (
                <Input
                    type={props.type ? props.type : "text"}
                    name={props.name}
                    data-cy={props.dataCy}
                    placeholder={props.placeHolder}
                    value={props.value || ""}
                    disabled={props.disabled}
                    pattern={props.pattern}
                    maxLength={props.maxLength}
                    onChange={handleChange}
                    onBlur={onBlur}
                    invalid={!valid}
                    innerRef={inputRef}
                    min={props.min}
                    max={props.max}
                    autoComplete={props.autoComplete}
                />
            )}

            {mandatory && isNotFilled && props.invalidInputMessage && !props.inputValidation ? (
                <InvalidLabel
                    data-cy={props.dataCy + "-error-label"}
                    small={props.invalidMessageSmall ? props.invalidMessageSmall.toString() : false.toString()}
                >
                    {props.invalidInputMessage}
                </InvalidLabel>
            ) : mandatory && isNotFilled ? (
                <InvalidLabel
                    data-cy={props.dataCy + "-error-label"}
                    small={props.invalidMessageSmall ? props.invalidMessageSmall.toString() : false.toString()}
                >
                    Das Feld wird benötigt.
                </InvalidLabel>
            ) : (
                !valid && (
                    <InvalidLabel
                        data-cy={props.dataCy + "-error-label"}
                        small={props.invalidMessageSmall ? props.invalidMessageSmall.toString() : false.toString()}
                    >
                        {props.invalidInputMessage}
                    </InvalidLabel>
                )
            )}
        </CustomFormGroup>
    );
};

export default PathwayTextInputGroup;

PathwayTextInputGroup.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    handleChange: PropTypes.func.isRequired,
    dataCy: PropTypes.string,
    pattern: PropTypes.string,
    maxLength: PropTypes.string,
    placeHolder: PropTypes.string,
    tooltip: PropTypes.string,
    invalidInputMessage: PropTypes.any,
    mandatory: PropTypes.bool,
    autoFocus: PropTypes.bool,
    disabled: PropTypes.bool,
    inputValidation: PropTypes.func,
    triggerOnBlur: PropTypes.func,
    invalidMessageSmall: PropTypes.bool,
    strongLabel: PropTypes.bool,
    autoComplete: PropTypes.string,
};

const CustomFormGroup = styled(PathwayFormGroup)`
    justify-items: normal;
    margin-bottom: 0 !important;
`;
const InvalidLabel = styled(Label)`
    position: absolute;
    color: var(--danger);
    font-size: ${(props) => (stringUtils.equals(props.small, "true") ? "0.6rem" : "0.75rem")};
    bottom: ${(props) => (stringUtils.equals(props.small, "true") ? "-0.95rem" : "-1.1rem")};
`;

const LabelWrapper = styled(PathwayLabel)`
    display: grid;
    grid-template-columns: auto min-content;
`;

const LabelParagraph = styled.p`
    ${(props) =>
        props.strong &&
        css`
            font-weight: bolder;
        `}
    margin: 0;
`;

const TooltipInputGroup = styled.div`
    display: grid;
    grid-template-columns: max-content min-content min-content;
    column-gap: var(--gap-s);
`;
